var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-field',[_c('span',{staticClass:"control"},[_c('b-button',{staticClass:"mr-2 mb-2",attrs:{"type":"is-info"},on:{"click":_vm.sendMessage}},[_vm._v(_vm._s(_vm.message.name))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }